module.exports = __webpack_public_path__ + "img/park.6501a357.png";